import { render } from "./Column202403.vue?vue&type=template&id=376d8344&scoped=true"
import script from "./Column202403.vue?vue&type=script&lang=js"
export * from "./Column202403.vue?vue&type=script&lang=js"

import "./Column202403.vue?vue&type=style&index=0&id=376d8344&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-376d8344"

export default script